import React from 'react';
import { withTheme } from 'styled-components';
export var OtrosIcon = function OtrosIcon(_ref) {
  var theme = _ref.theme;
  return React.createElement("svg", {
    width: "244px",
    height: "266px",
    viewBox: "0 0 244 266",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", null, "Otros"), React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("g", {
    id: "Otros",
    transform: "translate(-61.000000, -2.000000)",
    stroke: theme.colors.primary,
    strokeWidth: "15"
  }, React.createElement("g", {
    transform: "translate(34.000000, 1.000000)",
    id: "Money-Payments-Finance__x2F__Crypto-Currencies__x2F__crypto-currency-bitcoin"
  }, React.createElement("g", {
    transform: "translate(34.000000, 8.000000)"
  }, React.createElement("g", {
    id: "Group_126"
  }, React.createElement("g", {
    id: "crypto-currency-bitcoin"
  }, React.createElement("path", {
    d: "M114.71,185.6 C150.73,185.6 179.94,156.4 179.94,120.37 C179.94,84.35 150.74,55.14 114.71,55.14 C78.69,55.14 49.48,84.34 49.48,120.37 C49.48,156.39 78.68,185.6 114.71,185.6 Z",
    id: "Oval_48"
  }), React.createElement("line", {
    x1: "37.67",
    y1: "37.85",
    x2: "71.38",
    y2: "71.56",
    id: "Shape_1057"
  }), React.createElement("path", {
    d: "M22.3,44.27 C34.31,44.27 44.04,34.54 44.04,22.53 C44.04,10.52 34.31,0.79 22.3,0.79 C10.29,0.79 0.56,10.52 0.56,22.53 C0.56,34.53 10.29,44.27 22.3,44.27 Z",
    id: "Oval_49"
  }), React.createElement("line", {
    x1: "191.74",
    y1: "37.85",
    x2: "158.03",
    y2: "71.56",
    id: "Shape_1058"
  }), React.createElement("path", {
    d: "M207.12,44.27 C219.13,44.27 228.86,34.54 228.86,22.53 C228.86,10.52 219.13,0.79 207.12,0.79 C195.11,0.79 185.379992,10.52 185.379992,22.53 C185.37,34.53 195.11,44.27 207.12,44.27 Z",
    id: "Oval_50"
  }), React.createElement("path", {
    d: "M114.71,250.82 C126.72,250.82 136.45,241.09 136.45,229.08 C136.45,217.07 126.72,207.34 114.71,207.34 C102.7,207.34 92.9699923,217.07 92.9699923,229.08 C92.96,241.09 102.7,250.82 114.71,250.82 Z",
    id: "Oval_51"
  }), React.createElement("line", {
    x1: "114.71",
    y1: "185.6",
    x2: "114.71",
    y2: "207.34",
    id: "Shape_1059"
  }))))))));
};
export default withTheme(OtrosIcon);